import { Stack } from 'expo-router'

export function Layout() {
  return (
    <Stack>
      <Stack.Screen name="statement-credit" options={{ headerShown: false }} />
      <Stack.Screen name="redemption-confirmation" options={{ headerShown: false }} />
      <Stack.Screen name="success-confirmation" options={{ headerShown: false }} />
    </Stack>
  )
}
